/* Premium product card behaviour — lights toggle, quick add, variant drawer, size chips.
   Loaded once per page (guarded); all events are delegated so cards added
   by infinite scroll, sorting or fetched sections keep working. */
(function () {
  if (window.__pcPremiumInit) return;
  window.__pcPremiumInit = true;

  /* ---------------- Lights on/off ---------------- */
  var LIGHTS_KEY = 'azhara-lights-off';

  function lightsWraps() {
    return document.querySelectorAll('.pc-premium__image-wrap--lights');
  }

  function lightsOffStored() {
    try { return sessionStorage.getItem(LIGHTS_KEY) === 'true'; } catch (e) { return false; }
  }

  function storeLightsOff(off) {
    try { sessionStorage.setItem(LIGHTS_KEY, off ? 'true' : 'false'); } catch (e) { /* no-op */ }
  }

  function eagerLoad(img) {
    if (img && img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
  }

  function setWrap(wrap, off) {
    if (!wrap) return;
    if (off) eagerLoad(wrap.querySelector('.pc-premium__image--lights-off'));
    wrap.classList.toggle('is-lights-off', off);
    var btn = wrap.querySelector('[data-lights-toggle]');
    if (btn) btn.setAttribute('aria-pressed', off ? 'true' : 'false');
  }

  function setMaster(off) {
    storeLightsOff(off);
    lightsWraps().forEach(function (wrap) { setWrap(wrap, off); });
    var m = document.querySelector('[data-lights-master]');
    if (m) {
      m.setAttribute('aria-pressed', off ? 'true' : 'false');
      var lbl = m.querySelector('[data-lights-master-label]');
      if (lbl) lbl.textContent = off ? 'Lights off' : 'Lights on';
    }
  }

  function refreshLights() {
    var wraps = lightsWraps();
    /* Preload the off image so the crossfade never shows a blank frame */
    wraps.forEach(function (wrap) {
      eagerLoad(wrap.querySelector('.pc-premium__image--lights-off'));
    });
    var masterWrap = document.querySelector('[data-lights-master-wrap]');
    if (masterWrap) {
      if (wraps.length > 0) masterWrap.removeAttribute('hidden');
      else masterWrap.setAttribute('hidden', '');
    }
    if (lightsOffStored()) {
      setMaster(true);
    }
  }

  /* ---------------- Money formatting ---------------- */
  function formatMoney(cents, moneyFmt) {
    var a = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var s = moneyFmt || '{{ amount }}';
    s = s.replace(/\{\{\s*amount\s*\}\}/g, a);
    s = s.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, a.replace('.', ','));
    s = s.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return s;
  }

  /* ---------------- Variant drawer (pcd) ---------------- */
  var pcdState = {};
  var openDrawerId = null;

  function getState(id) {
    if (pcdState[id]) return pcdState[id];
    var drawer = document.querySelector('[data-drawer="' + id + '"]');
    var dataEl = drawer && drawer.querySelector('[data-pcd-data="' + id + '"]');
    if (!drawer || !dataEl) return null;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var best = data.variants.filter(function (v) { return v.avail; })
      .sort(function (a, b) { return b.inv - a.inv; })[0] || data.variants[0];
    pcdState[id] = { data: data, selected: best.opts.slice() };
    return pcdState[id];
  }

  function findVariant(state) {
    return state.data.variants.find(function (v) {
      return v.opts[0] === state.selected[0] && v.opts[1] === state.selected[1] && v.opts[2] === state.selected[2];
    });
  }

  function q(id, attr) {
    return document.querySelector('[' + attr + '="' + id + '"]');
  }

  function syncOptions(id, state) {
    var drawer = q(id, 'data-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('[data-pcd-option]').forEach(function (btn) {
      var pos = parseInt(btn.dataset.position, 10) - 1;
      var active = state.selected[pos] === btn.dataset.value;
      if (btn.dataset.isColor === 'true') {
        btn.classList.toggle('pcd__swatch--active', active);
      } else {
        btn.classList.toggle('pcd__option-btn--active', active);
      }
    });
  }

  function updateDrawerUI(id) {
    var state = getState(id);
    if (!state) return;
    var v = findVariant(state);
    var fmt = state.data.moneyFormat;
    var priceEl = q(id, 'data-pcd-price');
    var compareEl = q(id, 'data-pcd-compare');
    var thumbEl = q(id, 'data-pcd-thumb');
    var addBtn = q(id, 'data-pcd-add');
    var statusEl = q(id, 'data-pcd-status');
    var lowStockEl = q(id, 'data-pcd-low-stock');
    var lowStockText = q(id, 'data-pcd-low-stock-text');

    if (v && priceEl) {
      priceEl.textContent = formatMoney(v.price, fmt);
      if (compareEl) {
        if (v.cp > v.price) {
          compareEl.textContent = formatMoney(v.cp, fmt);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (v.img && thumbEl) thumbEl.src = v.img;
    }
    if (lowStockEl) {
      if (v && v.avail && v.inv > 0 && v.inv < 50) {
        lowStockEl.style.display = '';
        if (lowStockText) lowStockText.textContent = 'Only ' + v.inv + ' left in stock';
      } else {
        lowStockEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (v && v.avail) {
        addBtn.classList.remove('pcd__add-btn--notify');
        addBtn.textContent = 'Add to cart';
      } else {
        /* Sold-out selection: offer notify on the product page instead of a dead button */
        addBtn.classList.add('pcd__add-btn--notify');
        addBtn.textContent = 'Notify me';
      }
    }
    if (statusEl) statusEl.textContent = '';
  }

  function openDrawer(id) {
    var state = getState(id);
    if (!state) return;
    var drawer = q(id, 'data-drawer');
    var overlay = q(id, 'data-drawer-overlay');
    /* Move to body so iOS doesn't clip inside overflow containers */
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
    if (overlay && overlay.parentNode !== document.body) document.body.appendChild(overlay);
    syncOptions(id, state);
    updateDrawerUI(id);
    if (overlay) overlay.classList.add('is-active');
    if (drawer) drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    openDrawerId = id;
  }

  function closeDrawer(id) {
    var drawer = q(id, 'data-drawer');
    var overlay = q(id, 'data-drawer-overlay');
    if (overlay) overlay.classList.remove('is-active');
    if (drawer) drawer.classList.remove('is-active');
    document.body.style.overflow = '';
    if (openDrawerId === id) openDrawerId = null;
  }

  function addFromDrawer(id) {
    var state = getState(id);
    if (!state) return;
    var v = findVariant(state);
    var addBtn = q(id, 'data-pcd-add');
    var statusEl = q(id, 'data-pcd-status');
    if (!v || !v.avail) {
      /* Notify me — take them to the PDP */
      if (state.data.url) window.location.href = state.data.url;
      return;
    }
    if (addBtn) {
      addBtn.textContent = 'Adding...';
      addBtn.classList.add('pcd__add-btn--disabled');
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (addBtn) {
          addBtn.textContent = 'Add to cart';
          addBtn.classList.remove('pcd__add-btn--disabled');
        }
        /* Close right away — the cart drawer is the confirmation */
        closeDrawer(id);
      })
      .catch(function () {
        if (addBtn) {
          addBtn.textContent = 'Add to cart';
          addBtn.classList.remove('pcd__add-btn--disabled');
        }
        if (statusEl) statusEl.textContent = 'Something went wrong. Please try again.';
      });
  }

  /* ---------------- Size chips (cards rendered with size_chips: true) ----------------
     The card carries the same variants JSON the drawer uses; selecting a chip
     rewrites price / compare-at / % off, the quick-add variant id and the
     card link in place. Delegated, so cards revealed or injected later work. */
  function cardVariants(card) {
    if (card.__pcVariants !== undefined) return card.__pcVariants;
    var el = card.querySelector('[data-pcd-data]');
    var data = null;
    if (el) { try { data = JSON.parse(el.textContent); } catch (e) { data = null; } }
    card.__pcVariants = data;
    return data;
  }

  function selectSize(chip) {
    if (chip.disabled) return;
    var card = chip.closest('.pc-premium');
    var data = card && cardVariants(card);
    if (!data) return;
    var id = parseInt(chip.getAttribute('data-size-chip'), 10);
    var v = data.variants.find(function (x) { return x.id === id; });
    if (!v) return;

    card.querySelectorAll('[data-size-chip]').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var fmt = data.moneyFormat;
    var onSale = v.cp > v.price;
    var pct = onSale ? Math.floor((v.cp - v.price) * 100 / v.cp) : 0;
    var priceEl = card.querySelector('.pc-premium__price-current');
    var compareEl = card.querySelector('.pc-premium__price-compare');
    var offEl = card.querySelector('.pc-premium__price-off');
    if (priceEl) {
      priceEl.textContent = formatMoney(v.price, fmt);
      priceEl.classList.toggle('pc-premium__price-current--sale', onSale);
    }
    if (compareEl) {
      compareEl.textContent = onSale ? formatMoney(v.cp, fmt) : '';
      compareEl.style.display = onSale ? '' : 'none';
    }
    if (offEl) {
      offEl.textContent = pct > 0 ? pct + '% off' : '';
      offEl.style.display = pct > 0 ? '' : 'none';
    }

    var addBtn = card.querySelector('[data-quick-add]');
    if (addBtn) addBtn.setAttribute('data-quick-add', v.id);
    var btnPrice = card.querySelector('.pc-premium__btn-price');
    if (btnPrice) btnPrice.textContent = formatMoney(v.price, fmt).replace(/\.00\b/, '');
    var link = card.querySelector('.pc-premium__link');
    if (link && data.url) {
      link.setAttribute('href', data.url + (data.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id);
    }
  }

  /* ---------------- Quick add (single-variant + size-chip cards) ---------------- */
  function quickAdd(btn) {
    if (btn.disabled) return;
    var variantId = parseInt(btn.getAttribute('data-quick-add'), 10);
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
        var url = btn.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
  }

  /* ---------------- Delegated events ---------------- */
  document.addEventListener('click', function (e) {
    var master = e.target.closest('[data-lights-master]');
    if (master) {
      e.preventDefault();
      setMaster(!lightsOffStored());
      return;
    }

    var lightsBtn = e.target.closest('[data-lights-toggle]');
    if (lightsBtn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = lightsBtn.closest('.pc-premium__image-wrap--lights');
      if (wrap) setWrap(wrap, !wrap.classList.contains('is-lights-off'));
      return;
    }

    var sizeChip = e.target.closest('[data-size-chip]');
    if (sizeChip) {
      e.preventDefault();
      e.stopPropagation();
      selectSize(sizeChip);
      return;
    }

    var quickBtn = e.target.closest('[data-quick-add]');
    if (quickBtn) {
      e.preventDefault();
      quickAdd(quickBtn);
      return;
    }

    var trigger = e.target.closest('[data-drawer-trigger]');
    if (trigger) {
      e.preventDefault();
      openDrawer(trigger.getAttribute('data-drawer-trigger'));
      return;
    }

    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer(closeBtn.getAttribute('data-drawer-close'));
      return;
    }

    var overlay = e.target.closest('[data-drawer-overlay]');
    if (overlay) {
      closeDrawer(overlay.getAttribute('data-drawer-overlay'));
      return;
    }

    var optionBtn = e.target.closest('[data-pcd-option]');
    if (optionBtn) {
      e.preventDefault();
      e.stopPropagation();
      var oid = optionBtn.getAttribute('data-pcd-option');
      var ostate = getState(oid);
      if (!ostate) return;
      ostate.selected[parseInt(optionBtn.dataset.position, 10) - 1] = optionBtn.dataset.value;
      syncOptions(oid, ostate);
      updateDrawerUI(oid);
      return;
    }

    var addBtn = e.target.closest('[data-pcd-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      addFromDrawer(addBtn.getAttribute('data-pcd-add'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawerId) closeDrawer(openDrawerId);
  });

  /* ---------------- Init + watch for appended cards ---------------- */
  function init() {
    refreshLights();
    if (window.MutationObserver) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          refreshLights();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
